import { render, staticRenderFns } from "./CustomerSearchView.vue?vue&type=template&id=13bb5e0e&scoped=true&"
import script from "./CustomerSearchView.vue?vue&type=script&lang=js&"
export * from "./CustomerSearchView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSearchView.vue?vue&type=style&index=0&id=13bb5e0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bb5e0e",
  null
  
)

export default component.exports